// extracted by mini-css-extract-plugin
export default {"ctaButton":"ThankYouText_ctaButton__SGXep"};